<template>
  <b-modal v-model="modalVisible" centered hide-footer title="選擇新增方式">
    <template #default>
      
      <div class="row">
        <div class="col">
          <b-button class="w-100" @click="batchBtnClicked">
            批次上傳
          </b-button>
        </div>

        <div class="col">
          <b-button class="w-100" @click="singleBtnClicked">
            單筆上傳
          </b-button>
        </div>
      </div>

    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'KegCreateSelectModal',
  data() {
    return {
      
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },
  watch: {
    
  },
  mounted() {
  },
  methods: {
    batchBtnClicked() {
      this.$emit('selected', 'batch');
    },
    singleBtnClicked() {
      this.$emit('selected', 'single');
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
